import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    setEmail('');
  };

  return (
    <footer className="bg-amber-50 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-building-line text-3xl text-gray-900"></i>
              </div>
              <span className="text-2xl font-bold text-gray-900">Mt Zion Renovation</span>
            </div>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Transforming commercial and residential spaces with exceptional craftsmanship and innovative design solutions for over 25 years.
            </p>
            <div>
              <p className="text-sm font-semibold text-gray-900 mb-3">Stay Updated</p>
              <form onSubmit={handleSubscribe} className="flex flex-col gap-3">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                  required
                />
                <button
                  type="submit"
                  className="px-6 py-2.5 bg-gray-900 text-white text-sm font-semibold rounded-lg hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer"
                >
                  Subscribe
                </button>
              </form>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-4">Services</h3>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Commercial Remodeling
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Retail Store Buildouts
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Restaurant Renovation
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Kitchen Remodeling
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Bathroom Renovation
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <a href="#about" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  About Us
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Our Process
                </a>
              </li>
              <li>
                <a href="#portfolio" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Portfolio
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="text-sm text-gray-600">(555) 123-4567</li>
              <li className="text-sm text-gray-600">info@mtzionrenovation.com</li>
              <li className="text-sm text-gray-600">
                123 Design Avenue<br />
                Los Angeles, CA 90001
              </li>
              <li className="text-sm text-gray-600">
                Mon-Fri: 8am - 6pm<br />
                Sat: 9am - 4pm
              </li>
            </ul>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-9 h-9 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-base text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-base text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-base text-white"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-300">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-600">
              © 2024 Mt Zion Renovation. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
